import { render, staticRenderFns } from "./CompetitionFilterInterestLayout.vue?vue&type=template&id=f160ddae&scoped=true"
import script from "./CompetitionFilterInterestLayout.vue?vue&type=script&lang=js"
export * from "./CompetitionFilterInterestLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f160ddae",
  null
  
)

export default component.exports